import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { onToast } from "@components/Toast";

import { TGetModelBioResponse, modelBioAPI } from "@api/bio";
import { EHttpStatusCode, processRequest } from "@api/config";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useBioQuery = () =>
	useAuthQuery({
		queryKey: [QUERY_KEYS.BIO],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_MODEL_BIO,
				request: (token) => modelBioAPI.getModelBioAsync({ token }),
			});
			return data;
		},
	});

export const useUpdateModelBioMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (body: TGetModelBioResponse) => {
			await processRequest({
				prefix: API_PREFIXES.UPDATE_MODEL_BIO,
				request: (token) => modelBioAPI.updateModelBioAsync({ token, body }),
			});

			return null;
		},
		onError: (error) => {
			if (error instanceof AxiosError && error.response?.status === EHttpStatusCode.CONFLICT) {
				onToast({
					id: "update-bio-conflict",
					message: "Error",
					description: "Please upload your profile photo",
				});
			}
		},
		onSuccess: () => {
			onToast({
				id: "update-bio-success",
				message: "Success",
				description: "Profile has been updated",
			});
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.BIO] });
		},
	});
};
